import React from 'react';
import { constructClassName } from '../../helper/common'; // Utility function to construct class names
import { Button as AButton, Form, Spin } from 'antd'; // Ant Design Button and Form components
import styles from './Button.module.scss'; // Custom styles for the Button component

import { LoadingOutlined } from '@ant-design/icons';

/**
 * Button Component
 *
 * A customizable button component that wraps the Ant Design Button and Form.Item.
 * Provides additional styling options and integrates with form fields.
 *
 * Props:
 * @param {Object} buttonProps - Props to customize the Ant Design Button.
 *    - className: String (Additional class names for styling)
 *    - type: String (Button type, e.g., "primary", "default")
 *    - danger: Boolean (Flag to apply danger styling)
 *    - Any other props supported by the Ant Design Button component.
 * @param {Object} formItemProps - Props to customize the surrounding Form.Item (if used within a form).
 * @param {String} text - The text content displayed inside the button.
 * @param {Function} onClick - Event handler for button click events.
 */
function Button({
  buttonProps = {},
  formItemProps,
  text,
  onClick,
  buttonIcon,
  loadingData,
  prefixIcon,
}) {
  const { className = '', type, disable = false } = buttonProps;
  return (
    <>
      {/* Form.Item for integration within forms, with custom props */}
      <Form.Item {...formItemProps} className="!mb-0">
        {/* Ant Design Button with extended functionality and custom styling */}
        <AButton
          {...buttonProps}
          className={constructClassName([
            className,
            styles['ant-btn'],
            styles[`ant-btn-${type}`],
            disable ? styles['ant-btn-disabled'] : '',
          ])}
          onClick={onClick}
          disabled={loadingData}
        >
          {prefixIcon ? (
            <img src={prefixIcon} alt="icon" className="w-4" />
          ) : (
            ''
          )}
          {loadingData ? <Spin size="small" /> : text}
          {buttonIcon ? (
            <img src={buttonIcon} alt="icon" className="w-4" />
          ) : (
            ''
          )}
        </AButton>
      </Form.Item>
    </>
  );
}

export default Button;
